
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, ArrowRight, Zap, Target, BarChart } from 'lucide-react';

export const BusinessRegistrationPage: React.FC = () => {
  const navigate = useNavigate();

  const benefits = [
    {
      icon: <Target className="text-brand-gold" size={24} />,
      title: "Visibilidade Direcionada",
      description: "Seja encontrado por pescadores que buscam exatamente o que você oferece."
    },
    {
      icon: <Zap className="text-brand-gold" size={24} />,
      title: "Site Profissional Grátis",
      description: "Crie um site incrível para sua pousada ou operação em minutos."
    },
    {
      icon: <BarChart className="text-brand-gold" size={24} />,
      title: "Gestão de Reservas",
      description: "Organize sua agenda e receba pagamentos de forma simplificada (em breve)."
    }
  ];

  const handleStart = () => {
    // Redireciona para o construtor (subdomínio builder)
    // Em dev local, usa localhost ou rota simulada
    if (window.location.hostname.includes('localhost')) {
        // Simulação local - apenas alerta ou redireciona para rota admin
        alert('Em produção, isso redirecionará para construtor.nossapesca.com');
        navigate('/login'); // Fallback local
    } else {
        window.location.href = 'https://construtor.nossapesca.com';
    }
  };

  return (
    <div className="min-h-screen bg-brand-midnight flex flex-col font-sans">

      <main className="flex-grow pt-20">
        <div className="bg-white/5 border-b border-white/10 py-20 text-white relative overflow-hidden">
            <div className="absolute inset-0 bg-glow-mesh-dark opacity-10"></div>
            <div className="container mx-auto px-6 relative z-10 text-center">
                <h1 className="text-4xl md:text-6xl font-black mb-6 font-display uppercase tracking-tight">
                    Impulsione seu Negócio de Pesca
                </h1>
                <p className="text-xl text-white/40 max-w-2xl mx-auto mb-10 font-medium">
                    Junte-se à maior plataforma de pesca esportiva do Brasil. Cadastre sua empresa e comece a receber mais clientes hoje mesmo.
                </p>
                <button 
                  onClick={handleStart}
                  className="bg-brand-orange text-white font-black py-5 px-12 rounded-xl text-lg shadow-glow-orange hover:scale-105 transition-all flex items-center gap-3 mx-auto font-display uppercase tracking-widest text-sm"
                >
                  Criar Cadastro Grátis <ArrowRight />
                </button>
            </div>
        </div>

        <div className="container mx-auto px-6 py-20">
            <div className="grid md:grid-cols-3 gap-12">
                {benefits.map((benefit, index) => (
                    <div key={index} className="bg-white/5 p-8 rounded-3xl border border-white/10 hover:border-brand-gold/20 transition-all">
                        <div className="bg-brand-gold/10 w-14 h-14 rounded-2xl flex items-center justify-center mb-6">
                            {benefit.icon}
                        </div>
                        <h3 className="text-xl font-black text-white mb-3 font-display">{benefit.title}</h3>
                        <p className="text-white/40 leading-relaxed font-medium">{benefit.description}</p>
                    </div>
                ))}
            </div>
        </div>
      </main>
    </div>
  );
};
